//namespace
window.QJTApp = window.QJTApp || { modules: {} };

QJTApp.modules.home             = QJTApp.modules.home || {};
QJTApp.modules.home.models      = QJTApp.modules.home.models || {};
QJTApp.modules.home.views       = QJTApp.modules.home.views || {};
QJTApp.modules.home.collections = QJTApp.modules.home.collections || {};
QJTApp.modules.home.routes      = QJTApp.modules.home.routes || {};


QJTApp.modules.home.views.ItemView = Marionette.ItemView.extend({
  
  tagName: 'article',
  
  className: 'panel post-item',
  
  attributes: function() {
    return {
      'data-id': this.model.id,
      'data-cid': this.cid
    };
  },

  getTemplate: function() {
    return '#itemtype' + this.model.get('type');
  },

  initialize: function() {

    //todo: verificar se é torneio e neste caso alterar className para 'panel post-item tournament'

    // bind the model change to re-render this view
    this.listenTo(this.model, 'change', this.render);
    

    var self = this;
    /*setInterval(function() {
      self.model.set('timeAgo', moment.unix(self.model.get('pubtime')).fromNow());
    }, 10000);*/
  },

  onRender: function() {
    //console.log('ItemView rendered - template: ' + this.template);
  }

});